/// <reference path="../../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />

import dispatcher from '../../dispatcher';
import { TranscriptionAlertActions, TranscriptionAlertButtonClickListener, TranscriptionAlertButtonType, TranscriptionAlertState } from './TranscriptionAlert';
import { LEARN_MORE_URL } from '../../../AppConstants';

/**
 * Shows a consent-required notification popup before transcription begins.
 * Caller passes callbacks for the Agree (primary) and Back (secondary) buttons.
 */
export function ShowTranscriptionComplianceNotification(onAgree?: () => void, onBack?: () => void): void {
  const listener: TranscriptionAlertButtonClickListener = {
    onButtonClicked(buttonType: TranscriptionAlertButtonType): void {
      if (buttonType === TranscriptionAlertButtonType.PRIMARY_BUTTON) {
        onAgree?.();
      } else if (buttonType === TranscriptionAlertButtonType.SECONDARY_BUTTON) {
        onBack?.();
      }
    }
  };

  const transcriptionAlertState: TranscriptionAlertState = {
    title: TranscriptionStrings.ConsentRequiredTitle,
    information: TranscriptionStrings.ConsentRequiredDescription,
    buttonInfo: {
      buttonType: TranscriptionAlertButtonType.PRIMARY_BUTTON | TranscriptionAlertButtonType.SECONDARY_BUTTON | TranscriptionAlertButtonType.LINK,
      primaryButtonText: TranscriptionStrings.ConsentRequiredAgreeButtonLabel,
      secondaryButtonText: TranscriptionStrings.ConsentRequiredBackButtonLabel,
      linkText: TranscriptionStrings.TranscriptionPaneLearnLabel,
      hyperLink: LEARN_MORE_URL,
      linkPlacement: 'body',
      buttonClickListener: listener
    }
  };

  dispatcher.dispatch({
    type: TranscriptionAlertActions.ShowTranscriptionAlert,
    payload: transcriptionAlertState
  });
}
